import React from 'react';
import { motion } from 'framer-motion';
import { guidesMockupUrl } from '../data/content';
export function Solution() {
  return <section className="w-full bg-slate-50 py-16 sm:py-24" aria-labelledby="solution-title" data-id="element-175" data-mp="1ek2plu0ambxn">
      <div className="mx-auto max-w-6xl px-6" data-id="element-176" data-mp="10seftxdinzju">
        <h2 id="solution-title" className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-navy-deep sm:text-4xl" data-id="element-177" data-mp="15sahvr2nlgwr">
          The Professional Standard Your Family Deserves — Finally Available For Every Home.
        </h2>

        <motion.img initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} src={guidesMockupUrl} alt="The Pharma-Masterclave — the six core guides shown side by side" className="mx-auto mt-12 w-full max-w-4xl rounded-2xl border border-slate-200 bg-white shadow-xl" loading="lazy" data-id="element-178" data-mp="vrqfgl3ee6cy" />

        <div className="mx-auto mt-12 max-w-3xl space-y-5 rounded-2xl border border-slate-200 bg-white p-8 text-lg leading-relaxed text-ink/80 sm:p-10" data-id="element-179" data-mp="6z7bg5xh6th0">
          <p data-id="element-180" data-mp="gr3apkbaspmt">
            Hospitals have pharmaceutical protocols. Pharmacies have safety systems. Professional
            caregivers have training.
          </p>
          <p className="font-semibold text-navy-deep" data-id="element-181" data-mp="btjuwfyyc4sr">Your home has none of that.</p>
          <p className="font-semibold text-navy-deep" data-id="element-182" data-mp="3k7k6bjybj43x">Until now.</p>
          <p data-id="element-183" data-mp="3g6qi0pgyrnai">
            The Pharma-Masterclave is the first complete home pharmacy safety system that gives any
            family — with no medical background — the exact tools, protocols, and knowledge that
            healthcare professionals use every day.
          </p>
          <p className="font-semibold text-trust-dark" data-id="element-184" data-mp="19epotmi5jcnx">
            Because the difference between a safe home and a dangerous one is not luck. It’s a
            system.
          </p>

          <div className="rounded-xl border border-navy/15 bg-navy/[0.04] p-6" data-id="element-185" data-mp="1cgu5nnrx94r5">
            <p className="text-base font-bold text-navy-deep" data-id="element-186" data-mp="1ciwx8c8q35xz">The Pharma-Masterclave</p>
            <p className="mt-1 text-sm font-medium uppercase tracking-wide text-ink/60" data-id="element-187" data-mp="1ggm8rkyjqip4">
              Visual Integrity &amp; Safety System
            </p>
            <p className="mt-3 text-sm font-semibold text-trust-dark" data-id="element-188" data-mp="1qgv8h8rqym99">
              6 Complete Guides + 3 Exclusive Action Tools
            </p>
          </div>
        </div>
      </div>
    </section>;
}